import { server } from './config'
import client from './client'

export default {
  getGenders(data = {}, config = {}) {
    return client.get(`${server}/checkin/api/genders?language=${data}`)
  }
}
